(() => {
    function initAyaaniSwipers(context = document) {
        if (window.innerWidth > 789 || typeof Swiper === "undefined") return;

        const cards = context.querySelectorAll(".product-grid .card-wrapper");

        cards.forEach((card) => {
            // 🔒 HARD CARD GUARD
            if (card.dataset.swiperInit === "1") return;

            const media = card.querySelector(".card__media .media");
            if (!media) return;

            // 🔒 HARD MEDIA GUARD
            if (media.classList.contains("swiper-initialized")) return;

            card.dataset.swiperInit = "1";
            media.classList.add("swiper-container");

            // ✅ Build wrapper only once
            if (!media.querySelector(".swiper-wrapper")) {
                const wrapper = document.createElement("div");
                wrapper.className = "swiper-wrapper";

                const frag = document.createDocumentFragment();
                while (media.firstChild) frag.appendChild(media.firstChild);
                wrapper.appendChild(frag);
                media.appendChild(wrapper);
            }

            media
                .querySelectorAll(".swiper-wrapper > *")
                .forEach((el) => el.classList.add("swiper-slide"));

            // // ✅ PAGINATION GUARD (MOST IMPORTANT)
            // let pagination = media.querySelector(".swiper-pagination");
            // if (!pagination) {
            //     pagination = document.createElement("div");
            //     pagination.className = "swiper-pagination swiper-pagination-progressbar";
            //     media.appendChild(pagination);
            // }

            let nextBtn = media.querySelector(".swiper-button-next");
            let prevBtn = media.querySelector(".swiper-button-prev");

            if (!nextBtn) {
                nextBtn = document.createElement("div");
                nextBtn.className = "swiper-button-next";
                media.appendChild(nextBtn);
            }

            if (!prevBtn) {
                prevBtn = document.createElement("div");
                prevBtn.className = "swiper-button-prev";
                media.appendChild(prevBtn);
            }

            requestIdleCallback(() => {
                const swiper = new Swiper(media, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    watchOverflow: true,
                    // pagination: {
                    //     el: pagination,
                    //     type: "progressbar",
                    // },
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    },
                    on: {
                        init() {
                            if (this.slides.length <= 1) {
                                nextBtn.style.display = "none";
                                prevBtn.style.display = "none";
                            }
                        },
                    },
                });

                media.classList.add("swiper-initialized");
            }, { timeout: 500 });
        });
    }

    function observeProductGrid() {
        if (window.__AyaaniSwiperObserverAttached) return;
        window.__AyaaniSwiperObserverAttached = true;

        const grid = document.querySelector(".product-grid");
        if (!grid) return;

        const observer = new MutationObserver((mutations) => {
            const hasNewCards = mutations.some((m) =>
                [...m.addedNodes].some(
                    (n) =>
                        n.nodeType === 1 &&
                        (n.classList?.contains("card-wrapper") ||
                            n.querySelector?.(".card-wrapper"))
                )
            );

            if (hasNewCards) {
                requestIdleCallback(() => initAyaaniSwipers(grid), { timeout: 600 });
            }
        });

        observer.observe(grid, { childList: true, subtree: true });

        requestIdleCallback(() => initAyaaniSwipers(grid), { timeout: 600 });
    }

    document.addEventListener("DOMContentLoaded", observeProductGrid);
    document.addEventListener("ajaxinate:loaded", () => initAyaaniSwipers(document));

    document.addEventListener("Ayaani:collection:reset", () => {
        // 🔥 FULL RESET
        document.querySelectorAll(".card-wrapper").forEach((card) => {
            delete card.dataset.swiperInit;
            const media = card.querySelector(".card__media .media");
            media?.classList.remove("swiper-initialized");
        });

        window.__AyaaniSwiperObserverAttached = false;

        requestAnimationFrame(() => {
            observeProductGrid();
            initAyaaniSwipers(document);
        });
    });
})();

(() => {

    function initContinueBrowsingSwiper(context = document) {

        if (typeof Swiper === "undefined") return;

        const swipers = context.querySelectorAll(".continue-your-browsing-for-content-swiper");

        swipers.forEach((el) => {

            const nextArrow = el.querySelector(".swiper-button-next");
            const prevArrow = el.querySelector(".swiper-button-prev");

            // destroy existing swiper
            if (el.swiper) {
                el.swiper.destroy(true, true);
            }

            new Swiper(el, {
                slidesPerView: "auto",
                spaceBetween: 10,
                observer: true,
                observeParents: true,
                loop: true,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: nextArrow,
                    prevEl: prevArrow,
                },

                breakpoints: {
                    480: {
                        slidesPerView: 2,
                    },
                    768: { slidesPerView: 2,
                     },
                    1024: { slidesPerView: 3,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                     },
                    1400: { slidesPerView: 3,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                     }
                }

            });

        });

    }

    document.addEventListener("DOMContentLoaded", () => {
        initContinueBrowsingSwiper(document);
    });

    document.addEventListener("ajaxinate:loaded", () => {
        initContinueBrowsingSwiper(document);
    });

    document.addEventListener("ayaani:collection:reset", () => {

        document
            .querySelectorAll(".continue-your-browsing-for-content-swiper")
            .forEach(el => delete el.dataset.swiperInit);

        requestAnimationFrame(() => {
            initContinueBrowsingSwiper(document);
        });

    });

    document.addEventListener("shopify:section:load", (e) => {
        initContinueBrowsingSwiper(e.target);
    });

})();